export const autoNumberFilterConditions = [];
//# sourceMappingURL=filters.js.map